<div class="p-8 w-100">
    <div class="d-flex justify-content-between align-items-start gap-4">
        <div class="fs-2 fw-bolder text-dark">
            <i class="fas fa-calculator text-primary fs-3 me-1"></i> {{ 'BASE_PRICE_BREAKDOWN_TITLE' | translate }}
        </div>
        <button class="btn btn-sm btn-icon btn-light" [attr.aria-label]="'CLOSE' | translate" (click)="close()">
            <i class="fas fa-times"></i>
        </button>
    </div>
    <div class="fs-7 text-muted mt-2"> {{ 'BASE_PRICE_BREAKDOWN_DESCRIPTION' | translate }} </div>

    <div class="d-flex justify-content-between align-items-center gap-4 rounded bg-light-primary py-3 px-4 mt-5">
        <div>
            <div class="fw-bold fs-5 text-dark"> {{ data.periodLabel }} </div>
            <div class="fs-8 text-muted"> {{ data.description }} </div>
        </div>
        <div class="text-nowrap"><span class="fw-bolder fs-2 text-primary"> {{ data.breakdown.basePrice | energy:'price' }} </span> {{ 'price' | energyUnit }}</div>
    </div>

    <!-- START: Offer prices -->
    <button type="button" class="section-toggle mt-4" [attr.aria-expanded]="isOpen('offer')" (click)="toggle('offer')">
        <span class="fs-5 fw-bold text-dark"> {{ 'BASE_PRICE_STEP_OFFER_PRICES' | translate }} </span>
        <i class="fas fs-7 text-muted" [ngClass]="isOpen('offer') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>
    <div *ngIf="isOpen('offer')" class="mt-2">
    <div class="fs-7 text-muted"> {{ 'BASE_PRICE_STEP_OFFER_PRICES_HINT' | translate }} </div>
    <div class="equipment mt-3">
    <table class="breakdown-table fs-7">
        <thead>
            <tr>
                <th>{{ 'BASE_PRICE_COL_PERIOD' | translate }}</th>
                <th>€/kWh</th>
                <th>€/MWh</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let period of pricedPeriods">
                <td>{{ period.labelKey | translate }}</td>
                <td>{{ data.offerPrices[period.key] | number:'1.2-4' }}</td>
                <td>{{ data.offerPrices[period.key] * 1000 | number:'1.2-2' }}</td>
            </tr>
        </tbody>
    </table>
    </div>
    </div>
    <!-- END: Offer prices -->

    <!-- START: Consumption basis -->
    <button type="button" class="section-toggle mt-4" [attr.aria-expanded]="isOpen('consumption')" (click)="toggle('consumption')">
        <span class="fs-5 fw-bold text-dark"> {{ 'BASE_PRICE_STEP_CONSUMPTION' | translate }} </span>
        <i class="fas fs-7 text-muted" [ngClass]="isOpen('consumption') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>
    <div *ngIf="isOpen('consumption')" class="mt-2">
    <div class="fs-7 text-muted">
        <ng-container *ngIf="!data.usesAverageConsumption; else averageBasis">
            <ng-container *ngIf="months > 1; else singleMonthBasis">
                {{ 'BASE_PRICE_CONSUMPTION_BASIS_PERIOD' | translate: { start: (data.deliveryStartDate | date:'MMM yyyy'), end: (data.deliveryEndDate | date:'MMM yyyy'), months: months } }}
            </ng-container>
            <ng-template #singleMonthBasis>
                {{ 'BASE_PRICE_CONSUMPTION_BASIS_MONTH' | translate: { month: (data.deliveryStartDate | date:'MMM yyyy') } }}
            </ng-template>
        </ng-container>
        <ng-template #averageBasis> {{ 'BASE_PRICE_CONSUMPTION_BASIS_AVERAGE' | translate }} </ng-template>
    </div>

    <!-- One table: a block per equipment, then all the equipments together, sharing the same period columns (– where a tariff has no such period) -->
    <div class="equipment mt-3" *ngIf="totalTable.rows.length > 0">
        <div class="fs-8 text-muted"> {{ 'BASE_PRICE_RECENT_CONSUMPTIONS' | translate: { count: totalTable.rows.length } }} </div>
        <table class="breakdown-table fs-7 mt-2">
            <thead>
                <tr>
                    <th>{{ 'BASE_PRICE_COL_MONTH' | translate }}</th>
                    <th *ngFor="let column of totalTable.columns">{{ getPeriodLabelKey(column) | translate }} ({{ 'consumption' | energyUnit }})</th>
                    <th>{{ 'BASE_PRICE_COL_TOTAL' | translate }} ({{ 'consumption' | energyUnit }})</th>
                </tr>
            </thead>
            <tbody *ngFor="let recent of recentTables">
                <tr class="group-row">
                    <td [attr.colspan]="totalTable.columns.length + 2">{{ recent.code }}</td>
                </tr>
                <tr *ngFor="let row of recent.rows">
                    <td>{{ row.date | date:'MMM yyyy' }}<span *ngIf="row.estimated" class="ms-1 text-muted">*</span></td>
                    <td *ngFor="let column of totalTable.columns" [class.text-muted]="row.estimated">{{ row.values[column] == null ? '–' : (row.values[column] | energy:'consumption':'1.3-3') }}</td>
                    <td class="fw-bold" [class.text-muted]="row.estimated">{{ row.total | energy:'consumption':'1.3-3' }}</td>
                </tr>
            </tbody>
            <tbody>
                <tr class="group-row">
                    <td [attr.colspan]="totalTable.columns.length + 2">{{ 'BASE_PRICE_TOTAL_CONSUMPTION' | translate }}</td>
                </tr>
                <tr *ngFor="let row of totalTable.rows">
                    <td>{{ row.date | date:'MMM yyyy' }}<span *ngIf="row.estimated" class="ms-1 text-muted">*</span></td>
                    <td *ngFor="let column of totalTable.columns" [class.text-muted]="row.estimated">{{ row.values[column] | energy:'consumption':'1.3-3' }}</td>
                    <td class="fw-bold" [class.text-muted]="row.estimated">{{ row.total | energy:'consumption':'1.3-3' }}</td>
                </tr>
            </tbody>
        </table>
        <div class="fs-9 text-muted mt-1" *ngIf="hasEstimatedRows(totalTable.rows)">* {{ 'BASE_PRICE_ESTIMATED_MONTH' | translate }}</div>
    </div>
    </div>
    <!-- END: Consumption basis -->
 
    <!-- START: Equipments -->
    <button type="button" class="section-toggle mt-4" [attr.aria-expanded]="isOpen('equipments')" (click)="toggle('equipments')">
        <span class="fs-5 fw-bold text-dark"> {{ 'BASE_PRICE_STEP_EQUIPMENTS' | translate }} </span>
        <i class="fas fs-7 text-muted" [ngClass]="isOpen('equipments') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>
    <div *ngIf="isOpen('equipments')" class="mt-2">
    <div class="fs-7 text-muted"> {{ 'BASE_PRICE_STEP_EQUIPMENTS_HINT' | translate }} </div>

    <!-- One table: a block per equipment (with its tariff), then all the equipments together -->
    <div class="equipment mt-3">
        <table class="breakdown-table fs-7">
            <thead>
                <tr>
                    <th>{{ 'BASE_PRICE_COL_PERIOD' | translate }}</th>
                    <th>{{ 'BASE_PRICE_COL_CONSUMPTION' | translate }} ({{ 'consumption' | energyUnit }})</th>
                    <th>{{ 'price' | energyUnit }}</th>
                    <th>{{ 'BASE_PRICE_COL_COST' | translate }} (€)</th>
                </tr>
            </thead>
            <tbody *ngFor="let equipment of data.breakdown.equipments">
                <tr class="group-row">
                    <td colspan="4">
                        {{ equipment.code }}
                        <span class="badge badge-light text-gray-700 fs-8 ms-2"> {{ getTariffCycleLabelKey(equipment.tariffCycle) | translate }} </span>
                    </td>
                </tr>
                <tr *ngFor="let slot of equipment.slots">
                    <td>{{ getPeriodLabelKey(slot.priceKey) | translate }}</td>
                    <td>{{ slot.consumption | energy:'consumption':'1.3-3' }}</td>
                    <td>{{ slot.pricePerKWh * 1000 | energy:'price':'1.2-4' }}</td>
                    <td>{{ slot.cost | number:'1.2-2' }}</td>
                </tr>
                <tr class="subtotal-row">
                    <td>{{ 'BASE_PRICE_SUBTOTAL' | translate }}</td>
                    <td>{{ equipment.totalConsumption | energy:'consumption':'1.3-3' }}</td>
                    <td>{{ equipment.pricePerMWh | energy:'price':'1.2-4' }}</td>
                    <td>{{ equipment.cost | number:'1.2-2' }}</td>
                </tr>
            </tbody>
            <tbody>
                <tr class="group-row">
                    <td colspan="4">{{ 'BASE_PRICE_ALL_EQUIPMENTS' | translate }}</td>
                </tr>
                <tr *ngFor="let term of weightedTerms">
                    <td>{{ getPeriodLabelKey(term.key) | translate }}</td>
                    <td>{{ term.consumption | energy:'consumption':'1.3-3' }}</td>
                    <td>{{ term.pricePerMWh | energy:'price':'1.2-4' }}</td>
                    <td>{{ term.consumption * term.pricePerMWh | number:'1.2-2' }}</td>
                </tr>
                <tr class="subtotal-row">
                    <td>{{ 'BASE_PRICE_SUBTOTAL' | translate }}</td>
                    <td>{{ data.breakdown.totalConsumption | energy:'consumption':'1.3-3' }}</td>
                    <td>{{ data.breakdown.basePrice | energy:'price':'1.2-4' }}</td>
                    <td>{{ data.breakdown.cost | number:'1.2-2' }}</td>
                </tr>
            </tbody>
        </table>
    </div>
    </div>
    <!-- END: Equipments -->

    <!-- START: Final value -->
    <button type="button" class="section-toggle mt-4" [attr.aria-expanded]="isOpen('final')" (click)="toggle('final')">
        <span class="fs-5 fw-bold text-dark"> {{ 'BASE_PRICE_STEP_FINAL' | translate }} </span>
        <i class="fas fs-7 text-muted" [ngClass]="isOpen('final') ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
    </button>
    <div *ngIf="isOpen('final')" class="rounded border border-dashed border-gray-300 bg-light py-3 px-4 mt-2 fs-7">
        <div class="formula fw-semibold text-dark">
            {{ 'BASE_PRICE_LABEL' | translate }} =
            <span class="fraction">
                <span class="numerator">{{ 'BASE_PRICE_WEIGHTED_NUMERATOR' | translate }}</span>
                <span class="denominator">{{ 'BASE_PRICE_WEIGHTED_DENOMINATOR' | translate }}</span>
            </span>
        </div>
        <div class="formula text-muted mt-2">
            =
            <span class="fraction">
                <span class="numerator"><ng-container *ngFor="let term of weightedTerms; let last = last">({{ term.consumption | energy:'consumption':'1.3-3' }} {{ 'consumption' | energyUnit }} × {{ term.pricePerMWh | energy:'price' }} {{ 'price' | energyUnit }})<ng-container *ngIf="!last"> + </ng-container></ng-container></span>
                <span class="denominator"><ng-container *ngFor="let term of weightedTerms; let last = last">{{ term.consumption | energy:'consumption':'1.3-3' }}<ng-container *ngIf="!last"> + </ng-container></ng-container> {{ 'consumption' | energyUnit }}</span>
            </span>
        </div>
        <div class="formula text-muted mt-2">
            =
            <span class="fraction">
                <span class="numerator">{{ data.breakdown.cost | number:'1.2-2' }} €</span>
                <span class="denominator">{{ data.breakdown.totalConsumption | energy:'consumption':'1.3-3' }} {{ 'consumption' | energyUnit }}</span>
            </span>
        </div>
        <div class="formula mt-2">
            = <span class="fw-bolder text-primary fs-5">{{ data.breakdown.basePrice | energy:'price' }} {{ 'price' | energyUnit }}</span>
        </div>
    </div>
    <!-- END: Final value -->

    <div class="fs-8 text-muted mt-3">
        <i class="fas fa-circle-info me-1"></i> {{ 'BASE_PRICE_BREAKDOWN_FOOTNOTE' | translate }}
    </div>

    <div class="d-flex justify-content-end mt-6">
        <button class="btn btn-primary" (click)="close()"> {{ 'CLOSE' | translate }} </button>
    </div>
</div>
